








































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  CreateGripAnalysisStrategyPayload,
  CreateGripStrategyBase,
  GripAnalysisStrategy,
  GripItemReloadDTO,
  GripItemType,
  GripStrategyDTO,
  GripStrategyStatus,
  UpdateGripStrategyBase,
} from '../../../store/types/grip.types';
import BaseLoading from '../../../components/base/BaseLoading.vue';
import StrategyModal from '../Strategy/StrategyModal.vue';
import DeleteModalBox from '../../../components/DeleteModalBox.vue';
import { namespace } from 'vuex-class';
import { showUnsavedChangesDialog } from '@/utils/dialog.util';

const unsavedChangesGuard = namespace('unsavedChangesGuard');

@Component({
  components: {
    BaseLoading,
    StrategyModal,
    DeleteModalBox,
    GripAnalysisStrategies,
  },
})
export default class GripAnalysisStrategies extends Vue {
  @Prop() public projectId!: number;
  @Prop() public isDataCollector!: boolean;
  @Prop() public gripAnalysisId!: number;
  @Prop() public gripAnalysisEnablerId!: number;
  @Prop() public gripAnalysisStrategies!: GripAnalysisStrategy[];
  @Prop() public updatedItem!: GripItemReloadDTO;
  public isGripAnalysisStrategiesLoading: boolean = false;
  public showStrategyDraggableBox: boolean = false;
  public itemList: GripAnalysisStrategy[] = [];
  public tempDirtyStrategy: CreateGripStrategyBase = {
    title: '',
    description: '',
    resource: '',
    method: '',
    links: [],
    attachments: [],
    gripDomainCategoryId: null,
  };
  public modalKey: number = Math.floor(Math.random() * 999);
  public isModalActive: boolean = false;
  public isNew: boolean = false;
  public gripStrategyDetailsForEdit: GripStrategyDTO | null = null;
  public isMinimized: boolean = false;

  @unsavedChangesGuard.State('userSelectedKeepEditing')
  public userSelectedKeepEditing!: boolean;

  @unsavedChangesGuard.Action('notifyKeepEditingSelected')
  public notifyKeepEditingSelected!: () => void;

  @unsavedChangesGuard.Action('resetKeepEditingFlag')
  public resetKeepEditingFlag!: () => void;

  get editingStrategyId(): number | null {
    return this.isModalActive && !this.isNew && this.gripStrategyDetailsForEdit
      ? this.gripStrategyDetailsForEdit.id
      : null;
  }

  public getUpperCase(value: string): string {
    return value.toUpperCase();
  }

  public updated(): void {
    if (this.updatedItem.item === GripItemType.AnalysisStrategy) {
      const element = document.getElementById(
        this.updatedItem.item + '_' + this.updatedItem.id,
      );
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else if (this.updatedItem.prevItemId) {
        const prevElement = document.getElementById(
          this.updatedItem.prevItemId as string,
        );
        if (prevElement) {
          prevElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }

    if (this.showStrategyDraggableBox) {
      const element = document.getElementById('strategyDropZone');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  public handleShowDraggableBox(): void {
    this.showStrategyDraggableBox = true;
  }

  public onDragOver(event: any): void {
    const dragSupported = event.dataTransfer.types.length;
    if (dragSupported) {
      event.dataTransfer.dropEffect = 'copy';
      event.preventDefault();
    }
  }

  public onDrop(event: any, id: string): void {
    event.preventDefault();
    const jsonData = event.dataTransfer.getData('application/json');
    const data = JSON.parse(jsonData);
    if (!data) {
      return;
    }
    const { itemType, ...strategyData } = data;
    if (id === 'strategyDropZone' && itemType === 'strategy') {
      const strategyPayload: CreateGripAnalysisStrategyPayload = {
        ...strategyData,
        gripAnalysisId: this.gripAnalysisId,
        gripAnalysisEnablerId: this.gripAnalysisEnablerId,
      };
      this.$emit('addGripAnalysisStrategy', { strategyPayload, isNew: false });
    }
  }

  private _resetLocalModalState(): void {
    this.isModalActive = false;
    this.isMinimized = false;
    this.gripStrategyDetailsForEdit = null;
    this.isNew = false;
    this.modalKey += 1;
  }

  public openStrategyModal(): void {
    this._resetLocalModalState();
    this.isNew = true;
    this.isModalActive = true;
  }

  public handleEdit(strategy: GripAnalysisStrategy): void {
    const { status, createdDate, updatedDate, ...strategyDetails } = strategy;

    this._resetLocalModalState();
    this.gripStrategyDetailsForEdit = strategyDetails as GripStrategyDTO;
    this.isNew = false;
    this.isModalActive = true;
  }

  public async closeStrategyModal(): Promise<void> {
    this._resetLocalModalState();
  }

  public minimizeStrategyModal(): void {
    this.isMinimized = true;
  }

  public restoreStrategyModal(): void {
    this.isMinimized = false;
  }

  public handleStrategyCreate(gripStrategy: CreateGripStrategyBase): void {
    const strategyPayload: CreateGripAnalysisStrategyPayload = {
      ...gripStrategy,
      gripAnalysisId: this.gripAnalysisId,
      gripAnalysisEnablerId: this.gripAnalysisEnablerId,
    };
    this.$emit('addGripAnalysisStrategy', {
      strategyPayload,
      isNew: true,
    });

    this._resetLocalModalState();

    this.showStrategyDraggableBox = false;
  }

  public handleStrategyUpdate(
    gripStrategyUpdateData: UpdateGripStrategyBase & { id: number },
  ): void {
    const { id, ...changesToApply } = gripStrategyUpdateData;
    let actualChangesExist = Object.keys(changesToApply).length > 0;

    if (this.gripStrategyDetailsForEdit) {
      let hasMeaningfulChange = false;
      for (const key in changesToApply) {
        if (changesToApply.hasOwnProperty(key)) {
          if (
            JSON.stringify((this.gripStrategyDetailsForEdit as any)[key]) !==
            JSON.stringify((changesToApply as any)[key])
          ) {
            hasMeaningfulChange = true;
            break;
          }
        }
      }
      actualChangesExist = hasMeaningfulChange;
    }

    if (actualChangesExist) {
      this.$emit('updateGripAnalysisStrategy', {
        ...gripStrategyUpdateData, // Send all data including ID
        gripAnalysisId: this.gripAnalysisId,
        gripAnalysisEnablerId: this.gripAnalysisEnablerId,
      });
      this.$emit('handleUpdatedItemReload', {
        item: GripItemType.AnalysisStrategy,
        id: gripStrategyUpdateData.id,
        prevItemId: this.getPrevItemId(gripStrategyUpdateData.id),
      });
    }
    // Always close modal and notify, regardless of whether an API call was made.
    this._resetLocalModalState();
  }

  public handleDelete(gripAnalysisStrategyId: number): void {
    this.$buefy.modal.open({
      parent: this,
      component: DeleteModalBox,
      hasModalCard: true,
      trapFocus: true,
      props: {
        modalTitle: 'Delete Strategy?',
        modalContent:
          'Are you sure you want to delete this strategy? This action cannot be undone.',
      },
      events: {
        close: () => {
          this.$emit('close');
        },
        confirm: () => {
          this.$emit('deleteGripAnalysisStrategy', gripAnalysisStrategyId);
          this.$emit('handleUpdatedItemReload', {
            item: GripItemType.AnalysisStrategy,
            id: gripAnalysisStrategyId,
            prevItemId: this.getPrevItemId(gripAnalysisStrategyId),
          });
        },
      },
    });
  }

  public getPrevItemId(gripStrategyId: number): string {
    const strategyIndex: number = this.itemList.findIndex(
      (item) => item.id === gripStrategyId,
    );

    return strategyIndex > 0
      ? GripItemType.AnalysisStrategy +
          '_' +
          this.itemList[strategyIndex - 1].id
      : GripItemType.AnalysisEnabler + '_' + this.gripAnalysisEnablerId;
  }

  @Watch('userSelectedKeepEditing')
  public onUserSelectedKeepEditing(newValue: boolean): void {
    this.resetKeepEditingFlag();
    if (newValue && this.isMinimized && this.isModalActive) {
      this.restoreStrategyModal();
    }
  }

  @Watch('gripAnalysisStrategies', { deep: true, immediate: true })
  public onGripAnalysisStrategiesChanged(
    newStrategies: GripAnalysisStrategy[] | undefined,
  ): void {
    if (newStrategies) {
      // Strategies are already filtered for ACTIVE status by GripAnalysisPane.
      this.itemList = [...newStrategies].sort((a, b) => a.id - b.id);
    } else {
      this.itemList = [];
    }
    // Note: showStrategyDraggableBox is not updated here.
  }
}
